import {classNames} from "scholastic-client-components/src/SharedPackages/classnames"
import React, {ReactNode, useContext} from "react"
import styles from "./AuthHeader.module.scss"
import {MobileContext} from "scholastic-client-components/src/context/mobileContext"
import {Box} from "scholastic-client-components/src/ui/Box/Box"
import {ReactComponent as BusinessLogo} from "./graphics/business_logo.svg"
import {ReactComponent as CorporateLogo} from "./graphics/corporate_logo.svg"
import {ReactComponent as EduLogo} from "./graphics/edu_logo.svg"

const logo = {
    business: <BusinessLogo className={classNames(styles.logo, styles.logo_business)} />,
    corporate: <CorporateLogo className={classNames(styles.logo, styles.logo_corporate)} />,
    edu: <EduLogo className={classNames(styles.logo, styles.logo_edu)} />,
}

interface IAuthHeading {
    onLogoClick?(): void

    text: string | ReactNode
    logoVariant?: keyof typeof logo
    mb?: number
}

export const AuthHeader: React.FC<IAuthHeading> = ({
    onLogoClick = () => window.location.replace("/auth"),
    text,
    mb,
    logoVariant = "corporate",
}) => {
    const {isMobile} = useContext(MobileContext)

    return (
        <Box
            mb={mb}
            adaptiveMode={isMobile}
            adaptiveMb={{
                startSize: mb,
                minSize: 1.25,
            }}
            flex={{alignItems: "center", columnDirection: true}}
        >
            <button
                className={classNames(styles.logoButton, styles.businessLogo)}
                onClick={onLogoClick}
                type={"button"}
                data-test="logo_button"
            >
                {logo[logoVariant]}
            </button>
            <h1 className={styles["auth-heading"]}>{text}</h1>
        </Box>
    )
}
